import { useRawComponentDidMount } from './hooks'
import { useState } from 'react'

// Declare global CookieManager type
declare global {
  interface Window {
    CookieManager?: {
      getConsent?: () => string[]
      showPreferenceCenter?: () => void
    }
  }
}

type CookieConsent = 'essential' | 'analytics' | 'functional' | 'personalized'

// Check cookie consent for functional cookies
const hasCookieConsent = (consentToCheck: CookieConsent) => {
  try {
    // If CookieManager is not defined, allow video (fallback)
    if (typeof window === 'undefined' || !window.CookieManager) {
      return true
    }

    const consent = window.CookieManager?.getConsent?.() as CookieConsent[]

    return consent?.includes(consentToCheck) === true
  } catch {
    // If there's any error, allow video (fallback)
    return true
  }
}

export const useHasCookieConsent = () => {
  const [hasFunctionalConsent, setHasFunctionalConsent] = useState(true)

  useRawComponentDidMount(() => {
    setHasFunctionalConsent(hasCookieConsent('functional'))

    const interval = setInterval(() => {
      setHasFunctionalConsent(hasCookieConsent('functional'))
    }, 500)

    return () => clearInterval(interval)
  })

  return { hasFunctionalConsent }
}
